import request from '../utils/request'

// 视频菜单列表
export function listcate(data) {
    return request({
        url: '/api/open/uni/listcate?parent_cate_value='+data.parent_cate_value,
        method: 'get'
    })
}
// 视频菜单列表
export function listvideo(data){
    return request({
        url: '/api/open/uni/listvideo?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&cate='+data.cate+'&keywords='+data.keywords,
        method: 'get'
    })
}

// 视频详情
export function videoinfo(data){
    return request({
        url: '/api/open/uni/videoinfo?id='+data.id,
        method: 'get'
    })
}

// 直播列表
export function listlive(data){
    return request({
        url: '/api/open/uni/listlive?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&cate='+data.cate+'&keywords='+data.keywords,
        method: 'get'
    })
}

// 课件列表
export function listcourse(data){
    return request({
        url: '/api/open/uni/listcourse?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&cate='+data.cate+'&keywords='+data.keywords,
        method: 'get'
    })
}

// 课件详情
export function courseinfo(data){
    return request({
        url: '/api/open/uni/courseinfo?id='+data.id,
        method: 'get'
    })
}

// 直播详情
export function detail(data){
    return request({
        url: '/api/open/uni/detail?id='+data.id,
        method: 'get'
    })
}

export function listManagementSystem(data){
    return request({
        url: '/api/open/uni/listManagementSystem',
        method: 'get',
        params: data
    })
}

export function managementSystemInfo(data){
    return request({
        url: '/api/open/uni/managementSystemInfo',
        method: 'get',
        params: data
    })
}